import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useForm, FormProvider } from 'react-hook-form';
import CbButton from '../../Buttons/CbButton';
import { TextAreaBase } from '../../inputs/TextAreaBase';
import { withFormController } from '../../hocs/forms';
import { sendRenewalQuoteDetailsEmail } from '../../../inbox/QuotesService';
import useNotifications from '../../../_lib/notifications/useNotifications';

const TextArea = withFormController(TextAreaBase);

const schema = Yup.object().shape({
  description: Yup.string().label('Description').required(),
});

export const RenewalWorkflowEmailAgency = ({ data, ...props }: any) => {
  const classes = useStyles();
  const history = useHistory();
  const notifications = useNotifications();
  const { handleSubmit, ...methods } = useForm({
    resolver: yupResolver(schema),
  });
  const { isSubmitted } = methods.formState;
  const { id: quoteId, product: productType } = data;

  const onSubmit = ({ description }: any) => {
    sendRenewalQuoteDetailsEmail(
      { quoteId },
      { quoteId, description, productType }
    )
      .then(() => {
        notifications.success('Email sent');
        props.close();
        history.push('/customer/policies');
      })
      .catch(() => {
        notifications.error(
          'Something went wrong, please try again in a few minutes'
        );
        props.close();
      });
  };

  return (
    // @ts-expect-error TS(2741): Property 'handleSubmit' is missing in type '{ chil... Remove this comment to see the full error message
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent style={{ padding: '2rem 5rem' }}>
          <h2 className={classes.header}>Binder# {data.quoteNumber} </h2>
          <Divider className={classes.divider} />
          <DialogContentText className={classes.subHeader}>
            Message to {data.agencyName}
          </DialogContentText>
          <Divider className={classes.divider} />
          <TextArea
            name="description"
            type="string"
            className={classes.textArea}
            placeholder="Please describe the desired changes to your policy"
            required
            minRows="6"
            maxRows="6"
          />
        </DialogContent>
        <DialogActions>
          <CbButton onClick={props.close} styleName="cancel">
            Cancel
          </CbButton>
          <CbButton type="submit" styleName="ctaButton" loading={isSubmitted}>
            Send
          </CbButton>
        </DialogActions>
      </form>
    </FormProvider>
  );
};

export const RenewalWorkflowEmailAgencyConfig = {
  RenewalWorkflowEmailAgency: {
    component: RenewalWorkflowEmailAgency,
    config: {
      title: 'Email Agent to Update Renewal Quote',
      fullWidth: true,
    },
  },
};

const useStyles = makeStyles(({ config }) => ({
  header: {
    fontSize: config.textSizes.canon,
    fontWeight: 600,
  },
  subHeader: {
    fontSize: config.textSizes.paragon,
    fontWeight: 600,
  },
  textArea: {
    width: '100%',
    padding: '0.75rem',
    marginTop: '0.7rem',
    fontFamily: config.fonts.stackSans,
    fontSize: config.textSizes.tertia,
    color: config.colors.white,
    '&::placeholder': {
      color: config.colors.white,
      fontStyle: 'italic',
    },
  },
  divider: {
    margin: '0.25rem 0 1.25rem 0',
  },
}));
